import { FB_TEMPLATE_LOADING, FB_TEMPLATE_SUCCESS, FB_TEMPLATE_FAILED,
    FB_TEMPLATES_ADD_MORE, CLEAR_ALL_TEMPLATE_DATAS, FB_TEMPLATES_UPDATE_FILTERS,
    FB_TEMPLATES_ADD_MORE_LOADING
} from '../actions/flowBuilderTemplate.action';
import { fbTemplatesInterface } from '../models/flowBuilder.interface';

const initialState: fbTemplatesInterface = {
    loading: true,
    error: false,
    message: "",
    data: [],
    total: 0,
    totalTemplates: 0,
    filteredLoading: false,
    subscribedToNumbers: false,
    filters: {
        search: "",
        services: ["all"]
    }
}

const fbTemplateReducer = (state: fbTemplatesInterface = initialState, action: any) : fbTemplatesInterface => {
    switch (action.type) {
        case FB_TEMPLATE_LOADING:
            return {
                ...state,
                loading: true,
                error: false
            }
        case FB_TEMPLATE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                data: action.payload.respose.data,
                total: action.payload.respose.total,
                totalTemplates: action.payload.respose.total,
                subscribedToNumbers: action.payload.respose.subscribed_numbers
            }
        case FB_TEMPLATE_FAILED:
            return {
                ...state,
                loading: false,
                filteredLoading: false,
                error: true,
                message: action.payload.error.message || ""
            }
        case FB_TEMPLATES_ADD_MORE_LOADING: 
            return {
                ...state
            }
        case FB_TEMPLATES_ADD_MORE: 
            return {
                ...state,
                error: false,
                data: [...state.data, ...action.payload.respose.data],
                total: action.payload.respose.total
            }
        case FB_TEMPLATES_UPDATE_FILTERS:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    search: action.payload.search,
                    services: action.payload.selectedChannels,
                }
            }
        case CLEAR_ALL_TEMPLATE_DATAS: 
            return {
                ...initialState,
                filters: {
                    ...initialState.filters
                }
            }
        default: 
            return state;
    }
}

export default fbTemplateReducer;